import { NATIONAL_ID_FORMATS } from '../../constants'
import type { NationalIdCountries } from '../../types'

export function getNationalIdFormat(country: NationalIdCountries) {
  return NATIONAL_ID_FORMATS[country]
}
